import React from 'react';
import { getSingularOrPlural } from 'src/utilities/getSingularOrPlural';
import {
  NumberOfItemsInTable,
  NumberOfItemsInTableProps,
} from 'src/components/enterprise/Parents/NumberOfItemsInTable/NumberOfItemsInTable';

export type NumberOfCorporateAccountsProps = Omit<
  NumberOfItemsInTableProps,
  'suffix'
>;

export const NumberOfCorporateAccounts: React.FC<NumberOfCorporateAccountsProps> =
  ({ totalResults, ...props }) => {
    const noun = getSingularOrPlural(totalResults, 'account');

    const suffix = `corporate ${noun}`;

    return (
      <NumberOfItemsInTable
        {...props}
        totalResults={totalResults}
        suffix={suffix}
      />
    );
  };
